import React from 'react'

const AdminProduct = () => {
  return (
    <div>Admin Product Pages</div>
  )
}

export default AdminProduct